import { render } from "./BulkFood.vue?vue&type=template&id=b4eec566&scoped=true"
import script from "./BulkFood.vue?vue&type=script&lang=js"
export * from "./BulkFood.vue?vue&type=script&lang=js"

import "./BulkFood.vue?vue&type=style&index=0&id=b4eec566&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4eec566"]])

export default __exports__